module.exports = __webpack_public_path__ + "static/media/gov-3.af342117.png";